import { ReactElement, useState } from 'react';

import { Tooltip } from '@braskai/ui-kit';

import { RECORDER_Z_INDEX } from './lib/zIndex';

type RecorderControlTooltipProps = {
  title: string;
  children: ReactElement;
  hideOnClick?: boolean;
};

export const RecorderControlTooltip = ({ title, children, hideOnClick = false }: RecorderControlTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHiddenByClick, setIsHiddenByClick] = useState(false);

  return (
    <Tooltip
      title={title}
      open={isOpen && !isHiddenByClick}
      placement="top"
      slotProps={{ popper: { sx: { zIndex: RECORDER_Z_INDEX } } }}
      disableInteractive
      onClose={() => setIsOpen(false)}
      onOpen={() => setIsOpen(true)}
    >
      <span
        style={{ display: 'inline-flex' }}
        onClickCapture={hideOnClick ? () => setIsHiddenByClick(true) : undefined}
        onMouseLeave={() => setIsHiddenByClick(false)}
      >
        {children}
      </span>
    </Tooltip>
  );
};
